export default __webpack_public_path__ + "static/404-f45f7c8259ccb525f9f2e3fe263325ea.png";